import React, { useEffect, useState } from "react";
import { Table, Spin } from "antd";
import apiClient from "../api_client";

const CoquillesTableMultiOtTag = ({ 
  baseUrl,
  labelAll = "Nb Total", 
  labelOk = "Nb OK", 
  labelNok = "Nb KO",
  labelExtra = null,
  showExtra = false,
  disableAutoRefresh = false
}) => {
  const [data, setData] = useState([]);
  const [isFirstLoad, setIsFirstLoad] = useState(true);

  const otTags = ['cap', 'keolis', 'keolis_noc'];

  const fetchData = async () => {
    try {
      const promises = otTags.map(tag => 
        apiClient.get(`${baseUrl}?ot_tag=${tag}`)
      );
      const results = await Promise.all(promises);
      
      const tableData = results.map((res, index) => ({
        key: otTags[index],
        ot_tag: otTags[index].toUpperCase().replace('_', ' '),
        all: res.data?.all ?? 0,
        ok: res.data?.ok ?? 0,
        nok: res.data?.nok ?? 0,
        iv_indispo: res.data?.iv_indispo ?? 0,
      }));

      setData(tableData);
      if (isFirstLoad) {
        setIsFirstLoad(false);
      }
    } catch (err) {
      console.error("Erreur lors du chargement :", err);
      if (isFirstLoad) {
        setIsFirstLoad(false);
      }
    }
  };

  useEffect(() => {
    if (!baseUrl) return;
    fetchData();
    if (!disableAutoRefresh) {
      const interval = setInterval(fetchData, 2000);
      return () => clearInterval(interval);
    }
  }, [baseUrl, disableAutoRefresh]);

  const columns = [
    {
      title: 'OT Tag',
      dataIndex: 'ot_tag',
      key: 'ot_tag',
      width: 150,
      align: 'center',
      render: (text) => (
        <span style={{ fontWeight: 600, color: '#262626' }}>{text}</span>
      ),
    },
    {
      title: labelAll,
      dataIndex: 'all',
      key: 'all',
      width: 120,
      align: 'center',
      render: (value) => (
        <span style={{ fontSize: '16px', fontWeight: 600, color: '#262626' }}>
          {value}
        </span>
      ),
    },
    {
      title: labelOk,
      dataIndex: 'ok',
      key: 'ok',
      width: 120,
      align: 'center',
      render: (value) => (
        <span style={{ fontSize: '16px', fontWeight: 600, color: '#52c41a' }}>
          {value}
        </span>
      ),
    },
    {
      title: labelNok,
      dataIndex: 'nok',
      key: 'nok',
      width: 120,
      align: 'center',
      render: (value) => (
        <span style={{ fontSize: '16px', fontWeight: 600, color: '#ff4d4f' }}>
          {value}
        </span>
      ),
    },
  ];

  // Ajouter la colonne extra si nécessaire
  if (showExtra && labelExtra) {
    columns.push({
      title: labelExtra,
      dataIndex: 'iv_indispo',
      key: 'iv_indispo',
      width: 120,
      align: 'center',
      render: (value) => (
        <span style={{ fontSize: '16px', fontWeight: 600, color: '#fa8c16' }}>
          {value}
        </span>
      ),
    });
  }

  return (
    <div style={{ marginBottom: '20px' }}>
      {isFirstLoad ? (
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          padding: '40px 0',
          background: '#fff',
          border: '1px solid #d9d9d9',
          borderRadius: '4px'
        }}>
          <Spin />
        </div>
      ) : (
        <Table
          columns={columns}
          dataSource={data}
          pagination={false}
          bordered
          size="middle"
          style={{
            background: '#fff',
            boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
          }}
        />
      )}
    </div>
  );
};

export default CoquillesTableMultiOtTag;
